/* eslint-disable react/no-unescaped-entities */
import { RightOutlined } from '@ant-design/icons';
import { styleVariables } from '@lib/common';
import { Col, Row } from 'antd';
import styled, { css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledTitle = styled.p.withConfig({
  displayName: "guideline-fill-in-blank-questioncomponent__StyledTitle",
  componentId: "sc-1m1hi60-0"
})(["font-weight:bold;"]);
var StyledStep1WrapperRow = styled(Row).withConfig({
  displayName: "guideline-fill-in-blank-questioncomponent__StyledStep1WrapperRow",
  componentId: "sc-1m1hi60-1"
})(["position:relative;margin-bottom:24px;"]);
var StyledImageCol = styled(Col).withConfig({
  displayName: "guideline-fill-in-blank-questioncomponent__StyledImageCol",
  componentId: "sc-1m1hi60-2"
})(["span{width:100% !important;}"]);
var LineWrapperStyle = css(["position:absolute;"]);
var StyledLine1 = styled.div.withConfig({
  displayName: "guideline-fill-in-blank-questioncomponent__StyledLine1",
  componentId: "sc-1m1hi60-3"
})(["", " width:65px;bottom:183px;right:427px;p{position:absolute;right:-97px;top:-12px;}"], LineWrapperStyle);
var StyledLine2 = styled.div.withConfig({
  displayName: "guideline-fill-in-blank-questioncomponent__StyledLine2",
  componentId: "sc-1m1hi60-4"
})(["", " width:54px;bottom:103px;right:422px;p{position:absolute;right:-134px;top:-12px;}"], LineWrapperStyle);
var StyledLineWithArrow = styled.div.withConfig({
  displayName: "guideline-fill-in-blank-questioncomponent__StyledLineWithArrow",
  componentId: "sc-1m1hi60-5"
})(["position:relative;border-bottom:1px solid ", ";.anticon{position:absolute;right:-4px;top:-7px;}"], styleVariables.colors.gold2);
var StyledRightOutlined = styled(RightOutlined).withConfig({
  displayName: "guideline-fill-in-blank-questioncomponent__StyledRightOutlined",
  componentId: "sc-1m1hi60-6"
})(["color:", ";"], styleVariables.colors.gold2);
var StyledTextRow = styled(Row).withConfig({
  displayName: "guideline-fill-in-blank-questioncomponent__StyledTextRow",
  componentId: "sc-1m1hi60-7"
})(["margin:24px 0;"]);
var StyledMiddleCol = styled(Col).withConfig({
  displayName: "guideline-fill-in-blank-questioncomponent__StyledMiddleCol",
  componentId: "sc-1m1hi60-8"
})(["display:flex;justify-content:center;"]);
var StyledMiddleLine = styled.div.withConfig({
  displayName: "guideline-fill-in-blank-questioncomponent__StyledMiddleLine",
  componentId: "sc-1m1hi60-9"
})(["height:100%;border-right:1px solid ", ";"], styleVariables.colors.gray3);
export var GuidelineFillInBlankQuestion = function GuidelineFillInBlankQuestion(_ref) {
  var step1Image = _ref.step1Image,
      step3Image = _ref.step3Image,
      circleRedImage1 = _ref.circleRedImage1,
      circleRedImage2 = _ref.circleRedImage2,
      exampleImage1 = _ref.exampleImage1,
      exampleImage2 = _ref.exampleImage2;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledTitle, {
      children: "B\u01B0\u1EDBc 1: Chu\u1EA9n b\u1ECB c\xE2u h\u1ECFi"
    }), /*#__PURE__*/_jsx("p", {
      children: "Ch\u1ECDn lo\u1EA1i c\xE2u h\u1ECFi l\xE0 \"\u0110i\u1EC1n v\xE0o ch\u1ED7 tr\u1ED1ng\"."
    }), /*#__PURE__*/_jsxs(StyledStep1WrapperRow, {
      children: [/*#__PURE__*/_jsx(StyledImageCol, {
        span: 12,
        children: step1Image
      }), /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledLine1, {
          children: /*#__PURE__*/_jsxs(StyledLineWithArrow, {
            children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx(StyledRightOutlined, {}), /*#__PURE__*/_jsx("p", {
              children: "Khung c\xE2u h\u1ECFi "
            })]
          })
        }), /*#__PURE__*/_jsx(StyledLine2, {
          children: /*#__PURE__*/_jsxs(StyledLineWithArrow, {
            children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx(StyledRightOutlined, {}), /*#__PURE__*/_jsx("p", {
              children: "Khung \u0111\xE1p \xE1n"
            })]
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(StyledTitle, {
      children: "B\u01B0\u1EDBc 2: \u0110i\u1EC1n th\xF4ng tin v\xE0o c\xE1c khung:"
    }), /*#__PURE__*/_jsxs(StyledTextRow, {
      children: [/*#__PURE__*/_jsx(StyledImageCol, {
        span: 1,
        children: circleRedImage1
      }), /*#__PURE__*/_jsxs(Col, {
        span: 23,
        children: [/*#__PURE__*/_jsx(StyledTitle, {
          children: "Khung c\xE2u h\u1ECFi "
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsxs(Col, {
            span: 11,
            children: [/*#__PURE__*/_jsx("p", {
              children: "C\xE2u h\u1ECFi l\xE0 h\xECnh \u1EA3nh \u0111\xE3 c\xF3 s\u1EB5n ph\u1EA7n \u0111\xE1nh d\u1EA5u, b\u1EA1n c\xF3 th\u1EC3 chuy\u1EC3n qua b\u01B0\u1EDBc 2."
            }), /*#__PURE__*/_jsx("p", {
              children: "Ho\u1EB7c \u0111o\u1EA1n v\u0103n \u0111\xE3 c\xF3 s\u1EB5n ph\u1EA7n \u0111\xE1nh d\u1EA5u, gi\xE1o vi\xEAn c\xF3 th\u1EC3 sang b\u01B0\u1EDBc 2"
            })]
          }), /*#__PURE__*/_jsx(StyledMiddleCol, {
            span: 1,
            children: /*#__PURE__*/_jsx(StyledMiddleLine, {})
          }), /*#__PURE__*/_jsxs(Col, {
            span: 11,
            children: [/*#__PURE__*/_jsx("p", {
              children: "C\xE2u h\u1ECFi l\xE0 \u0111o\u1EA1n v\u0103n m\u1EDBi, gi\xE1o vi\xEAn th\u1EF1c hi\u1EC7n theo c\xE1c b\u01B0\u1EDBc sau:"
            }), /*#__PURE__*/_jsxs("ul", {
              children: [/*#__PURE__*/_jsx("li", {
                children: "D\xE1n \u0111o\u1EA1n v\u0103n v\xE0o ph\u1EA7n khung c\xE2u h\u1ECFi"
              }), /*#__PURE__*/_jsx("li", {
                children: "X\xF3a c\xE2u tr\u1EA3 l\u1EDDi "
              }), /*#__PURE__*/_jsx("li", {
                children: "Thay th\u1EBF c\xE2u tr\u1EA3 l\u1EDDi b\u1EB1ng s\u1ED1 th\u1EE9 t\u1EF1 \u0111\u01B0\u1EE3c \u0111\u1EB7t trong ngo\u1EB7c \u0111\u01A1n (1). V\xED d\u1EE5 nh\u01B0 h\xECnh tr\xEAn"
              })]
            })]
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            span: 11,
            children: exampleImage1
          }), /*#__PURE__*/_jsx(StyledMiddleCol, {
            span: 1,
            children: /*#__PURE__*/_jsx(StyledMiddleLine, {})
          }), /*#__PURE__*/_jsx(Col, {
            span: 11,
            children: exampleImage2
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs(StyledTextRow, {
      children: [/*#__PURE__*/_jsx(StyledImageCol, {
        span: 1,
        children: circleRedImage2
      }), /*#__PURE__*/_jsx(Col, {
        span: 11,
        children: step3Image
      }), /*#__PURE__*/_jsxs(Col, {
        span: 11,
        children: [/*#__PURE__*/_jsx("p", {}), /*#__PURE__*/_jsx(StyledTitle, {
          children: "Khung \u0111\xE1p \xE1n"
        }), /*#__PURE__*/_jsx("p", {
          children: "C\xE2u h\u1ECFi l\xE0 \u0111o\u1EA1n v\u0103n m\u1EDBi, gi\xE1o vi\xEAn th\u1EF1c hi\u1EC7n theo c\xE1c b\u01B0\u1EDBc sau:"
        }), /*#__PURE__*/_jsxs("ul", {
          children: [/*#__PURE__*/_jsx("li", {
            children: "D\xE1n \u0111o\u1EA1n v\u0103n v\xE0o ph\u1EA7n khung c\xE2u h\u1ECFi"
          }), /*#__PURE__*/_jsx("li", {
            children: "X\xF3a c\xE2u tr\u1EA3 l\u1EDDi "
          }), /*#__PURE__*/_jsx("li", {
            children: "Thay th\u1EBF c\xE2u tr\u1EA3 l\u1EDDi b\u1EB1ng s\u1ED1 th\u1EE9 t\u1EF1 \u0111\u01B0\u1EE3c \u0111\u1EB7t trong ngo\u1EB7c \u0111\u01A1n (1). V\xED d\u1EE5 nh\u01B0 h\xECnh tr\xEAn"
          })]
        })]
      })]
    })]
  });
};